import { Injectable } from '@angular/core';
import { KYMW7004Model } from '../kymw7004.model';
import { FeatureRequestInfo } from '../vo/feature-request-info.model';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

// レスポンス構造
type GetFeatureRequestListResponse = {
  CatalogId: string,
  SupplierNameKanji: string,
  FeatureCode: string,
  FeatureName: string,
  SelectionFlag: number,
  ReplacementStatus: number,
  OrderCode: string,
  MediumType: string
}[];

/**
 * 特集商品提案状況一覧取得サービス
 * @export GetFeatureRequestListService
 * @class GetFeatureRequestListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetFeatureRequestListService extends PlessJsonResponderSub<GetFeatureRequestListResponse> {

  model: KYMW7004Model;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetFeatureRequestListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest();
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetFeatureRequestListService
   */
  execute(model: KYMW7004Model, f?: () => void): void {
    this.model = model;
    if (f) this.calbak = f;
    this.send('getFeatureRequestList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetFeatureRequestListService
   */
  success(data: GetFeatureRequestListResponse) {
    this.model.featureRequestList = data.map(_ => {
      const info = new FeatureRequestInfo(
        _.CatalogId,
        _.SupplierNameKanji,
        _.FeatureCode,
        _.FeatureName,
        Number(_.SelectionFlag),
        Number(_.ReplacementStatus),
        _.OrderCode,
        _.MediumType,
      );
      info.check = false;
      info.disabled = info.ReplacementStatus === 2 ? true : false;
      info.statusName = info.SelectionFlag === 2 ? '提案済み' : '提案前';
      return info;
    });

    if (this.calbak) this.calbak();
  }
  
}
